import { ICustomerData } from "@/entities";
import { Module } from "vuex";
import { IActions, IGetters, IMutations, ICartState } from "./cart.type";

export const getters: IGetters = {
    // getId: (state) => {
    //     return state.sale?.id;
    // },
};

export const mutations: IMutations = {
    setLoading: (state, payload) => {
        state.loading = payload;
    },
    setBasket: (state, payload) => {
        state.basket = payload;
    },
    clearBasket: (state) => {
        state.basket = undefined;
    },
    // setCustomers: (state, payload) => {
    //     // state.customers = payload;
    // }
};

export const actions: IActions = {
    async syncBasket(this, context, payload): Promise<void> {
        console.log("syncBasket:", payload);
        try {
            context.commit("setLoading", true);
            const apikey = await this.$services.authentication.getApikey();
            if (apikey) {
                const b = await this.$services.baskets.syncBasket(
                    {
                        basketId: (payload as ICustomerData).basketID,
                        ownerId: context.rootGetters["sale/getId"],
                        productList: [],
                        branchId: "any",
                    },
                    apikey!.key!
                );
                context.commit("setBasket", b);
            }
        } catch (error) {
            console.warn(error);
        } finally {
            context.commit("setLoading", false);
        }
    },
    async clearBasket(this, context, payload) {
        console.log("clearBasket", payload);
        try {
            context.commit("setLoading", true);
            const apikey = await this.$services.authentication.getApikey();
            if (apikey) {
                const b = await this.$services.baskets.clear(
                    context.state.basket!.basketId!,
                    apikey!.key!
                );
                context.commit("setBasket", b);
            }
        } catch (error) {
            console.warn(error);
        } finally {
            context.commit("setLoading", false);
        }
    },
    async addProduct(this, context, payload) {
        console.log("addProduct", payload);
        try {
            context.commit("setLoading", true);

            if (!context.state.basket) {
                throw Error("Please choose customer before adding item.");
            }

            const apikey = await this.$services.authentication.getApikey();
            if (apikey) {
                const b = await this.$services.baskets.addProduct(
                    context.state.basket!.basketId!,
                    payload,
                    apikey!.key!
                );
                context.commit("setBasket", b);
            }
        } catch (error) {
            console.warn(error);
            throw error;
        } finally {
            context.commit("setLoading", false);
        }
    },
    async incrementProduct(this, context, payload) {
        console.log("incrementProduct", payload);
        try {
            context.commit("setLoading", true);
            const apikey = await this.$services.authentication.getApikey();
            if (apikey) {
                const b = await this.$services.baskets.incrementProduct(
                    context.state.basket!.basketId!,
                    payload,
                    apikey!.key!
                );
                context.commit("setBasket", b);
            }
        } catch (error) {
            console.warn(error);
        } finally {
            context.commit("setLoading", false);
        }
    },
    async decrementProduct(this, context, payload) {
        console.log("decrementProduct", payload);
        try {
            context.commit("setLoading", true);
            const apikey = await this.$services.authentication.getApikey();
            if (apikey) {
                const b = await this.$services.baskets.decrementProduct(
                    context.state.basket!.basketId!,
                    payload,
                    apikey!.key!
                );
                context.commit("setBasket", b);
            }
        } catch (error) {
            console.warn(error);
        } finally {
            context.commit("setLoading", false);
        }
    },
    async updateProductQuantity(this, context, payload) {
        console.log("updateProductQuantity", payload);
        try {
            context.commit("setLoading", true);
            const apikey = await this.$services.authentication.getApikey();
            if (apikey) {
                const b = await this.$services.baskets.updateProduct(
                    context.state.basket!.basketId!,
                    payload.data,
                    payload.quantity,
                    apikey!.key!
                );
                context.commit("setBasket", b);
            }
        }
        catch (error) {
            console.warn(error)
        }
        finally {
            context.commit("setLoading", false);
        }
    },
    async removeProduct(this, context, payload) {
        console.log("removeProduct", payload);
        try {
            context.commit("setLoading", true);
            const apikey = await this.$services.authentication.getApikey();
            if (apikey) {
                const b = await this.$services.baskets.updateProduct(
                    context.state.basket!.basketId!,
                    payload,
                    -1000000000,
                    apikey!.key!
                );
                context.commit("setBasket", b);
            }
        } catch (error) {
            console.warn(error);
        } finally {
            context.commit("setLoading", false);
        }
    },
    // async (this, context, payload): Promise<void> {
    //     console.log("syncSale:", payload);
    //     try {
    //         context.commit("setLoading", true);
    //         const u = await this.$services.sales.syncSale(payload);
    //         context.commit("setSale", u.data());
    //         console.log(u.customerList());
    //         context.commit("setCustomers", u.customerList());
    //     } catch (error) {
    //         console.warn(error);
    //     } finally {
    //         context.commit("setLoading", false);
    //     }
    // },
};

const cart: Module<ICartState, ICartState> = {
    namespaced: true,
    state: {
        loading: true,
        basket: undefined,
        // sale: undefined,
        // customers: []
    },
    getters,
    mutations,
    actions,
};

export default cart;
